'use client';

import { Checkbox, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface RejectReasonCheckboxRowProps {
  /** 거절 사유 code (API 문자열). */
  value: string;
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  className?: string;
}

export const RejectReasonCheckboxRow = ({
  value,
  label,
  checked,
  onChange,
  className,
}: RejectReasonCheckboxRowProps) => {
  const id = `reject-reason-${value}`;
  return (
    <label
      htmlFor={id}
      className={twMerge('flex cursor-pointer items-center gap-[8px]', className)}
    >
      <Checkbox id={id} checked={checked} onCheckedChange={(next) => onChange(next === true)} />
      <Typography variant="body13pxReg" colorScheme="gray-600">
        {label}
      </Typography>
    </label>
  );
};
